module.exports = __webpack_public_path__ + "static/media/conjuring.124ae61c.jpg";